module.exports = new __parcel__URL__("pending.bef556ce.svg").toString();